import { getCurrentEnvironment, EnvironmentType } from '../../diagnostics/EnvironmentType'

let env = getCurrentEnvironment()
export const ONBOARDING_URL = 
	env === EnvironmentType.DEV ? 'https://onboarding-dev.gotrashy.com/'
	: env === EnvironmentType.STAGE ? 'https://onboarding-stage.gotrashy.com'
	: 'https://provider.curb-it.com/'



// WEBPACK FOOTER //
// ./src/config/onboarding/onboarding.ts